// extracted by mini-css-extract-plugin
module.exports = {"section":"lancamentos_section__Nkmye","text":"lancamentos_text__az3_c"};